import type { Setting } from "model/Workgroup";

const COMPANY_TIME_REPORT_STAMP_BEFORE_START_THRESHOLD =
  "CompanyTimeReportStampBeforeStartThreshold";
const COMPANY_TIME_REPORT_STAMP_AFTER_START_THRESHOLD =
  "CompanyTimeReportStampAfterStartThreshold";
const COMPANY_TIME_REPORT_STAMP_BEFORE_END_THRESHOLD =
  "CompanyTimeReportStampBeforeEndThreshold";
const COMPANY_TIME_REPORT_STAMP_AFTER_END_THRESHOLD =
  "CompanyTimeReportStampAfterEndThreshold";
const COMPANY_STAMP_CLOCK_ALLOW_EDIT_TIME = "CompanyStampClockAllowEditTime";

export interface ClockStampThresholds {
  beforeStartMinutes: number;
  afterStartMinutes: number;
  beforeEndMinutes: number;
  afterEndMinutes: number;
}

const resolveCompanySettingMinutes = (
  companySettings: Setting[] | undefined,
  key: string,
): number => {
  const raw =
    companySettings?.find((setting) => setting.key === key)?.value ?? "0";
  const parsed = Number(raw);
  if (!Number.isFinite(parsed) || parsed < 0) return 0;
  return parsed;
};

/** Resolves clock-stamp before/after thresholds from company settings with safe defaults. */
export const resolveClockStampThresholds = (
  companySettings: Setting[] | undefined,
): ClockStampThresholds => ({
  beforeStartMinutes: resolveCompanySettingMinutes(
    companySettings,
    COMPANY_TIME_REPORT_STAMP_BEFORE_START_THRESHOLD,
  ),
  afterStartMinutes: resolveCompanySettingMinutes(
    companySettings,
    COMPANY_TIME_REPORT_STAMP_AFTER_START_THRESHOLD,
  ),
  beforeEndMinutes: resolveCompanySettingMinutes(
    companySettings,
    COMPANY_TIME_REPORT_STAMP_BEFORE_END_THRESHOLD,
  ),
  afterEndMinutes: resolveCompanySettingMinutes(
    companySettings,
    COMPANY_TIME_REPORT_STAMP_AFTER_END_THRESHOLD,
  ),
});

/** Whether the worker can edit reported and break times when stamping. */
export const resolveCanEditTime = (
  companySettings: Setting[] | undefined,
): boolean => {
  const raw = companySettings?.find(
    (setting) => setting.key === COMPANY_STAMP_CLOCK_ALLOW_EDIT_TIME,
  )?.value;
  return raw?.trim().toLowerCase() === "true";
};
